import _ from 'lodash';
import numberFormatter from '../../utils/numberFormatter';

const getDistrictByStreet = (districts, streetName, number = null) => {
  for (const district of districts) {
    for (const street of district.streets) {
      if (street.street.toLowerCase() === streetName.toLowerCase()) {
        if (street.modifier === 'entire') {
          return district.district;
        } else if (street.modifier === 'list' && number !== null) {
          const houseNumbers = street.list.split(',').map(num => num.trim());
          if (houseNumbers.includes(number.toString())) {
            return district.district;
          }
        }
      }
    }
  }
  return undefined;
};

const countOtherDistricts = (form, votingSettings) => {
  const district = getDistrictByStreet(votingSettings.districtStreetsFilters, form.voter ? form.voter.address || '' : '', form.voter ? form.voter.number : '');
  if (!district) return 0;
  
  return form.applicationIds.filter(id => {
    const project = votingSettings.projects.find(p => p.id === id);
    return project && project.district !== district;
  }).length;
};

export const validateAnswers = (form, props) => {
  const errors = {};

  if (!form.voterIdentificationMethodId) errors.voterIdentificationMethodId = 'Wybór metody weryfikacji jest wymagany';

  if (props.votingSettings.type === 'singleChoice') {
    if (!form.applicationId) {
      errors.applicationId = {
        _error: 'Musisz wybrać jeden projekt',
      };
    }

    return errors;
  }

  if (props.votingSettings.type === 'multiChoice') {
    if (!form.applicationIds || !form.applicationIds.length) {
      errors.applicationIds = {
        _error: 'Musisz wybrać co najmniej jeden projekt',
      };

      return errors;
    }
    
    if (props.votingSettings.choiceLimits.min) {
      if (form.applicationIds.length < props.votingSettings.choiceLimits.min) {
        errors.applicationIds = {
          _error: `Minimalna liczba projektów do wybrania: ${props.votingSettings.choiceLimits.min}`,
        };
        return errors;
      }
    }

    
    if (props.votingSettings.choiceLimits.max) {
      if (form.applicationIds.length > props.votingSettings.choiceLimits.max) {
        errors.applicationIds = {
          _error: `Maksymalna liczba projektów do wybrania: ${props.votingSettings.choiceLimits.max}`,
        };
        return errors;
      }
    }

    if (props.votingSettings.choiceLimits.otherDistrictsMax) {
      if (countOtherDistricts(form, props.votingSettings) > props.votingSettings.choiceLimits.otherDistrictsMax) {
        errors.applicationIds = {
          _error: `Maksymalna liczba projektów do wybrania z obcych obszarów: ${props.votingSettings.choiceLimits.otherDistrictsMax}`,
        };
        return errors;
      }
    }
  }

  if (props.votingSettings.type === 'points') {
    if (!form.votes || !form.votes.length) {
      errors.votes = {
        _error: 'Musisz wybrać co najmniej jeden projekt',
      };

      return errors;
    }

    if (props.votingSettings.pointsLimitUniquenessConstraint) {
      const usedValues = form.votes ? form.votes.filter(v => v.value).map(v => v.value) : [];
      if (usedValues.length < props.votingSettings.pointsLimitMinimum || usedValues.length > props.votingSettings.pointsLimit) {
        errors.votes = {
          _error: props.votingSettings.pointsLimitMinimum === props.votingSettings.pointsLimit ? 'Należy wykorzystać wszystkie dostępne punkty' : `Minimalna liczba projektów do wybrania to ${props.votingSettings.pointsLimitMinimum}`,
        };
      }
      return errors;
    } else {
      let sum = 0;
      if (form.votes) {
        form.votes.forEach(c => sum += (parseFloat(c.value) || 0));
      }
      if (sum > props.votingSettings.pointsLimit) {
        errors.votes = {
          _error: 'Limit punktów do rozdysponowania został przekroczony',
        };
      }
      return errors;
    }
  }

  if (props.votingSettings.type === 'value') {
    if (!form.applicationIds || !form.applicationIds.length) {
      errors.applicationIds = {
        _error: 'Musisz wybrać co najmniej jeden projekt',
      };

      return errors;
    }

    if (props.votingSettings.amountLimit && props.votingSettings.amountLimit > 0) {
      let sum = 0;
      form.applicationIds.forEach(id => sum += parseFloat(props.votingSettings.projects.find(a => a.id === id).cost));
      if (_.round(sum, 2) > props.votingSettings.amountLimit) {
        errors.applicationIds = {
          _error: `Limit dostępnych środków został przekroczony (limit ogólny ${numberFormatter.format(props.votingSettings.amountLimit)} zł, wykorzystano ${numberFormatter.format(sum)} zł)`,
        };

        return errors;
      }
    }

    // Weryfikacja limitow obszarow
    if (props.votingSettings.districtsAmountsLimits) {
      props.votingSettings.districtsAmountsLimits
        .filter(district => district.amountLimit && district.amountLimit > 0)
        .forEach(district => {
          const projectsByDistrict = props.votingSettings.projects.filter(p => p.district === district.district && form.applicationIds.includes(p.id));
          let sum = 0;
          projectsByDistrict.forEach(project => sum += parseFloat(project.cost));

          console.debug(`Suma wybranych z obszaru ${district.district}`, sum);

          if (sum > district.amountLimit) {
            errors.applicationIds = {
              _error: `Limit dostępnych środków dla obszaru ${district.district} został przekroczony (dostępny limit ${numberFormatter.format(district.amountLimit)} zł, wykorzystano ${numberFormatter.format(sum)} zł)`,
            };
          }
        });
    }

    // Weryfikacja limitow kategorii
    if (props.votingSettings.categoriesAmountLimits) {
      props.votingSettings.categoriesAmountLimits
        .filter(category => category.amount && category.amount > 0)
        .forEach(category => {
          const projectsByCategory = props.votingSettings.projects.filter(p => p.category === category.category && form.applicationIds.includes(p.id));
          let sum = 0;
          projectsByCategory.forEach(project => sum += parseFloat(project.cost));

          console.debug(`Suma wybranych z kategorii ${category.category}`, sum);

          if (sum > category.amount) {
            errors.applicationIds = {
              _error: `Limit dostępnych środków dla kategorii ${category.category} został przekroczony (dostępny limit ${numberFormatter.format(category.amount)} zł, wykorzystano ${numberFormatter.format(sum)} zł)`,
            };
            return;
          }

          // Weryfikacja limitow podkategorii
          if (category.subcategories) {
            category.subcategories
              .filter(subcategory => subcategory.amount && subcategory.amount > 0)
              .forEach(subcategory => {
                const projectsBySubcategory = props.votingSettings.projects.filter(p => p.subcategory === subcategory.category && form.applicationIds.includes(p.id));
                let sum = 0;
                projectsBySubcategory.forEach(project => sum += parseFloat(project.cost));
      
                console.debug(`Suma wybranych z podkategorii ${subcategory.category}`, sum);
      
                if (sum > subcategory.amount) {
                  errors.applicationIds = {
                    _error: `Limit dostępnych środków dla podkategorii ${subcategory.category} został przekroczony (dostępny limit ${numberFormatter.format(subcategory.amount)} zł, wykorzystano ${numberFormatter.format(sum)} zł)`,
                  };
                  return;
                }
              });
          }
        });
    }

    return errors;
  }

  return errors;
};



// WEBPACK FOOTER //
// ./src/models/budget/budgetSubmissionValidation.js